import SystemTooltip from "../SystemTooltip";
import useTooltipsControl from "@hooks/useTooltipsControl";
import { SystemsMapProps } from "../models/SystemIconData";

/* eslint-disable @next/next/no-img-element */
const LombardiaSystemsMap = ({ iconsData }: SystemsMapProps) => {
  const { toggle, opened } = useTooltipsControl();
  const openFirst = () => toggle("1");
  const openSecond = () => toggle("2");
  const openThird = () => toggle("3");

  return (
    <svg viewBox="0 0 512 480" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M325.526 21.4358L327.713 21.8182L333.728 21.4358L345.921 24.9874L348.983 24.4957L350.35 22.31L351.389 23.4028L353.03 29.3587L353.74 30.8887L355.381 33.73L356.365 34.8228L357.295 35.5332L365.387 37.0085L370.144 39.2487L378.128 44.6036L379.495 46.0242L379.987 47.7728L380.37 49.6305L381.627 56.8978V59.9031L381.409 60.9412L381.08 61.9248L380.424 63.0176L379.877 63.8372L378.073 65.695L376.815 66.6239L376.05 67.0064L374.464 67.6075L372.496 67.7714L368.504 67.4435L367.629 67.6075L366.536 68.1539L363.474 70.8313L362.325 73.454L368.887 78.7542L370.691 81.1038L370.91 81.9781L371.129 83.8905V84.874L370.91 85.8576L370.637 86.7865V88.6443L370.855 91.1031L372.058 96.5126L372.332 99.0807V100.829L369.652 107.55L368.121 110.61L367.739 111.812L367.465 113.451L367.356 119.79L366.153 129.352L365.825 130.718L365.442 131.483L364.95 132.139L359.701 137.111L358.443 138.094L357.677 139.624L356.748 141.919L355.436 147.602L354.615 150.115L353.905 151.7L351.717 152.957L350.842 153.886L349.968 155.361L348.765 158.639L348.327 160.497L348.163 161.973L348.327 162.847L348.71 163.557L349.257 164.158L349.913 164.595L350.788 164.978L354.342 166.016L354.834 166.453L355.053 167.054L355.217 168.147V171.425L355.436 172.573L355.654 173.447L355.928 174.321L356.201 175.141L357.568 177.655L358.115 179.185V180.277L357.896 181.261L356.748 183.72L355.928 186.179L355.709 187.709V188.856L356.748 191.752L358.279 197.872L358.716 199.128L359.208 199.73L359.919 200.221L362.763 200.986L363.638 201.478L364.403 202.352L364.512 203.5L363.856 206.614L364.075 207.598L364.567 208.308L366.098 209.128L367.739 209.784L368.668 209.947H369.543L370.363 209.62L371.019 209.182L373.371 206.942L374.136 206.614L375.011 206.45L379.167 206.778L381.135 206.614L381.955 206.341L382.721 205.959L383.268 205.358L383.705 204.647L383.978 203.828L384.143 202.899L384.361 200.932L384.58 200.003L384.908 199.183L385.4 198.473L386.002 197.981L386.767 197.708L389.556 197.981L390.485 197.872L393.93 196.943H394.805L395.789 197.052L396.61 197.38L398.797 198.637L399.617 198.855H400.601L406.179 198.036H407.764L408.475 198.2L410.881 199.183L413.998 201.041L406.397 212.133L405.522 213.718L402.788 220.111L398.797 226.668L396.117 229.673L377.854 256.01L377.198 260.654L376.925 267.539L378.292 283.713L377.964 293.002L377.526 293.33L376.815 294.805L376.706 296.116L377.034 297.865L377.8 300.597L379.768 303.384L384.252 302.291L386.876 302.619L387.095 307.755L386.603 312.618L387.095 314.804L389.282 316.443V318.027L387.259 319.831L387.041 325.841L385.455 328.081L389.118 329.338L390.978 328.792H391.907L392.891 329.284L393.711 330.54L394.204 331.578L394.805 333.382L395.188 334.147L395.735 334.638L396.445 334.857L397.484 334.474L398.195 333.983L398.797 333.327L399.672 331.961L400.273 331.415L400.984 331.141L402.351 331.633L404.046 332.781L409.405 338.299L410.17 339.72L411.154 342.07L411.592 342.725L428.379 356.331L434.229 358.735L435.596 359.5L436.581 360.374L437.893 362.068L438.385 362.942L438.658 363.817V364.582L438.44 365.237L437.784 366.877L437.62 367.423L437.51 368.243V369.008L437.729 369.554L438.002 370.046L438.768 370.483L439.916 370.756H442.103L444.509 370.374H445.493L446.368 370.865L447.189 372.067L447.353 373.16L447.134 374.089L446.368 375.565L446.095 376.384L445.931 377.313L446.095 378.187L446.368 379.007L446.806 379.717L448.884 382.449L449.704 383.16L451.071 383.979L452.219 384.252L453.422 384.034L454.68 383.105L455.391 382.231L456.047 381.575L456.703 381.247L461.788 380.755L463.1 380.264L464.085 379.663L464.741 379.171L466.053 379.007L468.022 379.28L473.38 381.029L474.419 383.05L471.849 385.017L471.302 385.618L470.974 386.329V387.148L471.521 392.667L471.63 393.159L474.693 394.252L485.191 394.361L485.082 400.754L490.714 406L505.313 415.999L508.321 416.327L510.617 417.747L511 421.955L502.142 419.824L490.222 419.168L489.347 419.496L488.691 419.933L488.198 420.643L487.324 422.556L486.066 423.43H485.246L482.129 422.228L469.443 425.725L465.616 425.834L465.069 425.233L463.592 423.212L463.046 422.72L462.335 422.228L452.875 418.13L451.563 418.021L436.799 419.824L436.307 420.206L435.815 420.753L435.268 421.354L434.393 422.829L433.573 423.485L432.425 424.086L427.066 425.233L425.59 425.889L424.879 426.381L422.801 427.474L417.169 429.331L415.091 427.965L414.49 427.419L413.123 426.435L412.029 425.889L395.352 421.463L394.696 420.917L394.368 420.261V419.441L394.696 418.676L395.078 417.857L395.297 416.982V416.054L395.078 415.179L394.75 414.36L394.258 413.704L393.766 413.158L391.415 411.081L390.813 410.753L388.626 410.535L385.947 410.644L384.525 410.371L383.486 409.988L382.94 409.497L380.752 410.262L377.636 415.616L372.058 421.9L366.426 425.998L360.083 427.528L352.319 427.2L344.718 425.233L338.758 421.791L336.462 418.075L333.837 409.715L331.267 408.021L327.713 408.513L325.252 409.442L322.628 409.606L318.581 407.693L300.756 395.563L293.757 393.268L286.593 393.869L279.868 395.672L274.072 394.907L269.807 387.749L266.854 379.881L266.471 378.023L265.76 376.657L262.48 374.198L261.769 372.942L259.855 371.904L247.279 376.657L248.7 371.193L245.365 369.008L241.647 369.991L241.865 374.035L244.271 378.788L243.615 380.591H240.936L233.609 378.624L232.078 379.116L233.171 382.231L233.718 384.69L232.515 386.056L230.875 385.837L230.109 383.87L228.797 381.794L222.509 377.422L220.759 374.035H219.665L219.556 375.182L219.392 375.401H219.064L218.572 375.674L218.408 382.121L213.049 384.362L205.886 383.378L200.308 380.154L198.231 378.515L198.012 377.313V374.144L198.559 372.778L199.27 371.576L199.16 370.592L197.082 369.936L194.567 370.592L192.489 372.341L190.247 373.652L187.295 372.996L185.271 369.39L183.85 367.915L182.045 368.625L181.335 370.428L181.553 372.505L182.1 374.745L182.319 377.094L181.499 379.881L179.803 379.28L176.413 375.947L174.445 375.455L172.914 375.237L169.086 375.728L161.158 375.455L159.845 378.734L159.08 380.373L153.284 389.17L141.145 414.36L139.668 416.491L138.629 418.512L138.192 419.824L137.809 421.408L137.536 424.031L137.645 425.561L137.919 426.709L138.301 427.419L139.34 428.621L139.996 429.167L141.473 430.042L144.644 431.517L145.902 432.501L146.394 433.102L146.722 433.812L146.941 434.686L147.05 435.724V436.817L146.175 443.156L143.441 448.237L139.067 454.576L137.591 457.526L136.825 459.602V460.586L137.098 461.46L138.629 466.597L139.286 470.312V471.296L139.176 472.443L138.629 473.427L137.591 474.683L136.716 475.339L135.403 475.667H133.763L130.646 475.011L129.279 474.301L128.459 473.481L127.639 470.913L127.256 470.148L126.655 469.93L125.944 470.257L125.452 471.787V472.935L125.397 475.175L125.233 476.159L124.741 478.016L123.046 479L117.523 477.962L118.726 468.4L118.179 465.558L117.632 465.012L116.976 463.864L116.101 462.007L113.367 452.117L111.672 448.073L110.961 446.762L110.305 445.778L109.704 445.232L109.048 444.795L108.282 444.412L104.29 443.647L100.025 443.483L98.6584 442.882L97.018 441.735L94.284 438.511L93.1357 436.872L92.4796 435.506L92.3702 434.577L92.5343 433.593L92.753 432.61L93.6279 431.025L93.9559 430.096V428.566L93.7372 427.583L93.2451 426.872L84.1135 417.911L80.9421 413.977L80.1219 412.502L79.7392 411.19L80.2859 409.169L80.3953 407.803L80.0125 405.453L79.5204 404.196L78.9736 403.268L78.1534 402.229L77.8254 401.956L76.6224 401.082L75.146 400.481L69.9514 399.825L68.8032 399.388L67.6549 398.732L65.249 396.929L64.9209 396.547L64.5928 395.782L64.3741 395.071L64.21 394.252L64.046 393.323V392.339V391.246L65.249 385.072V383.706L64.7569 383.378L59.945 382.012L56.9376 383.16L46.2203 389.061L42.1193 389.607L35.4484 389.334L32.1676 387.749L30.0897 387.476L27.6838 389.006L23.7469 384.744L21.6143 379.717L17.8961 367.86L12.2094 360.32L10.9518 355.948L10.6237 355.566L9.58475 353.326L9.25669 352.069L8.87391 349.829L10.405 346.332L10.1862 345.621L9.80348 344.747L8.87391 343.873L7.78032 342.671L6.30396 340.048L6.08524 338.299L6.24927 336.824L6.74139 335.075L6.468 334.201L5.81184 333.436L4.99164 332.835L4.11676 331.305V326.606L3.78869 325.185L3.07784 324.202L2.20297 323.546L1.21872 322.399L1 321.306V320.432L1.32809 319.831L2.47636 318.191L3.4606 316.388L5.81184 313.875L7.2882 310.378L8.54584 306.553L9.42072 304.859L10.2409 303.766L11.0064 303.438L12.0454 303.274L14.7793 303.384L22.3799 305.515L23.9109 306.225L24.6217 306.717L25.1685 307.318L26.0434 308.738L26.7543 310.214L29.2149 316.552L30.0897 317.536L31.3474 318.519L34.4642 319.721L35.8312 319.94L36.7607 319.831L37.1982 319.23L37.4715 318.355L38.0183 315.35L38.2917 314.421L38.6745 313.602L39.1666 312.837L39.7134 312.236L40.9164 311.197L45.8376 308.575L46.5484 307.974L46.8765 307.263V306.444L46.439 305.788L45.8376 305.241L43.705 303.93L43.1036 303.384L43.2129 302.509L48.6809 298.958L60.5465 295.133L57.5391 291.144L57.1017 290.161L53.274 277.976L52.1258 275.189L51.1415 273.44L50.4307 273.003L47.0405 271.637L43.4317 268.523L42.4474 266.993L41.8459 265.791V263.441L41.4632 261.747L40.5883 259.015L40.2055 257.321L40.0962 256.065L40.4789 253.66L38.8932 251.42L39.5494 246.939L39.3307 245.792L39.0026 244.808L34.6282 239.071L34.0267 237.377L34.136 236.503H34.8469H35.6671L36.4873 236.394L37.2528 235.356V234.263L36.6513 232.733L36.4873 231.367V230.001L36.6513 228.252L36.3779 227.378L35.6671 227.05L33.9173 227.269L32.9878 227.05L31.9489 226.067L31.5661 225.083V224.045L32.2223 222.078L32.5503 220.657L32.7144 218.253L32.3863 216.996L31.8942 216.122L30.5819 215.248L27.0277 214.155L25.6607 212.406L23.9656 209.401L20.4661 201.861L19.3178 198.418L18.935 196.123L19.2631 195.358L19.7552 194.648L20.2473 194.047L24.0203 191.042L24.5124 190.386L25.0045 189.621L25.3326 188.856L25.7153 188.036L25.8794 186.506L25.442 179.075L24.4577 174.376L24.239 170.497V168.639L24.6764 167.546L25.1685 166.89L48.3529 144.487L49.0637 143.449L49.7199 142.029L50.6494 139.078L50.9228 137.384L51.0322 135.963L50.8134 120.609L51.3055 120.773L52.4539 123.177L53.7115 124.161L56.4455 124.653L61.6948 124.762L64.2647 125.8L68.3657 131.811L65.577 137.493L60.3278 143.285L56.9923 150.115L56.2814 151.263L55.9534 151.919L58.9061 152.246L61.476 153.285L71.1544 159.077L72.248 160.005L73.2869 161.645L74.7633 165.688L77.552 171.152L78.8096 174.485L79.6298 177.764L79.7392 182.08L78.8643 185.14L77.716 188.036L76.8958 191.861L83.8402 190.058L89.3628 192.79L94.5574 193.992L100.353 187.435L105.056 179.239L105.931 175.032L104.126 170.824L102.541 169.732L98.7678 168.857L97.1274 167.819L95.7057 165.47L94.4481 160.88L92.6983 158.858L92.3702 158.257L92.2609 157.601L92.4249 156.946L92.8077 156.345L98.7131 151.372L96.0338 142.575L96.9087 139.788L101.447 136.564L105.275 135.526L106.97 134.652L108.446 132.412L109.102 129.407L108.993 123.778L109.813 120.609L113.203 115.965L126.108 107.987V107.878L127.584 105.474L128.514 102.632L129.553 100.174L131.466 98.8621L133.544 97.9879L135.622 96.1847L137.317 93.7805L140.215 84.9833L145.683 74.6562L146.995 69.2467L146.886 66.0229L144.972 57.1164L145.082 53.5647L145.683 50.4502L145.464 47.9367L143.223 46.2428L141.746 42.8551L143.332 36.7899L146.558 30.9433L149.948 28.0473L158.314 27.337L161.704 28.3752V31.4351L165.915 35.8064L167.172 36.4074L169.032 35.6971L169.906 34.2218L170.563 32.5279L171.766 30.9433L174.609 29.0309L175.976 28.7577L176.413 30.3422L176.523 54.1658L176.14 57.936L176.413 59.302L177.616 60.5588L181.335 62.799L182.811 64.1104L185.873 73.1808L187.951 76.2408L191.505 78.8635L195.442 80.4481L215.127 81.377L218.408 80.1749L221.142 76.6232L221.306 74.6562L221.142 71.8148L221.579 68.9735L223.493 66.9518L225.352 67.0611L229.453 69.7931L231.64 70.2849L235.249 69.2467L246.841 63.7826L254.387 62.6898L257.668 63.0722L261.167 64.0558L265.378 67.0064L266.362 71.0498V75.9675L267.237 81.4863L269.643 84.9833L276.259 91.2124L277.899 95.4744V101.102L283.531 101.376L290.859 98.8621L295.725 95.9662L298.186 91.267L296.053 86.7865L289.218 79.3553L287.742 76.514L287.086 74.4376L287.25 72.1427L288.234 68.8096L289.601 66.46L293.264 63.3455L294.522 61.7062L295.998 56.3514L294.795 53.5101L291.897 52.2533L284.242 50.5594L279.266 48.4284L276.696 44.9861L279.923 39.9591L278.446 38.9209L277.626 37.5002L277.298 35.6424L277.134 33.3475L277.954 30.7247L278.173 25.2606L278.446 23.5121L279.977 21.3265L283.805 17.7748L285.281 15.917L287.632 7.88477L288.453 6.02697L290.148 5.20735L306.442 1L310.871 1.10927L313.496 3.4042L313.769 6.1909L312.676 11.2725L313.332 14.0046L320.331 16.5727L321.643 17.8294L322.464 19.0862L323.557 20.2336L325.416 21.2172L325.526 21.4358Z"
        fill="#001A70"
        stroke="#84B5E7"
        strokeMiterlimit="10"
      />

      <SystemTooltip
        className="system-tooltip"
        open={opened === "1"}
        closeTooltip={toggle}
        href={iconsData?.at(0)?.href}
        title={iconsData?.at(0)?.label || "Title"}
      >
        <g onMouseEnter={openFirst} onClick={openFirst}>
          <path
            d="M132.496 359.289C132.496 359.289 134.166 361.731 134.166 365.166C134.166 369.26 132.031 373.037 127.489 374.401C127.537 368.513 123.605 369.965 121.647 365.166C118.237 368.188 118.367 370.941 118.309 374.401C115.474 373.54 112.467 371.069 112.467 366.006C112.467 361.719 115.805 358.526 115.805 355.092C115.805 355.092 118.647 355.623 119.144 359.289C121.944 356.258 122.482 353.489 122.482 350.055C127.129 353.036 128.324 356.083 128.324 361.808C130.219 361.435 131.244 360.623 132.496 359.289Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M98.3381 355.102C100.25 355.643 101.906 355.929 103.339 355.929C112.525 355.93 112.525 347.536 112.525 337.461C108.229 339.982 95.8345 339.108 95.8345 348.382C95.8345 350.203 96.1276 352.924 98.3381 355.102Z"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M115.864 339.979C119.202 339.979 122.315 340.919 124.969 342.547"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M107.435 342.473C103.087 345.168 99.1894 349.835 98.4467 355.141C98.3382 355.947 98.2798 356.77 98.2798 357.609C98.2798 366.827 105.307 374.383 114.261 375.164"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M115.805 339.979C124.927 339.979 132.413 346.98 133.247 355.938"
            stroke="white"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <SystemTooltip
        className="system-tooltip"
        open={opened === "2"}
        closeTooltip={toggle}
        href={iconsData?.at(1)?.href}
        title={iconsData?.at(1)?.label || "Title"}
      >
        <g onMouseEnter={openSecond} onClick={openSecond}>
          <path
            d="M207.952 226.809V242.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M213.032 226.809V242.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M207.952 242.047H213.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M207.952 226.809H213.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M246.048 226.809V242.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M240.968 242.047H246.048"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M240.968 226.809V242.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M246.048 226.809H240.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M213.032 239.508H240.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M213.032 229.35H223.19"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M240.968 229.35H230.81"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M223.19 226.809V229.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M230.81 226.809V229.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M223.19 226.809H230.809"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M227 221.731C231.909 221.731 235.889 217.751 235.889 212.842C235.889 207.933 231.909 203.953 227 203.953C222.091 203.953 218.111 207.933 218.111 212.842C218.111 217.751 222.091 221.731 227 221.731Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M227 212.842L230.592 209.25"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M224.46 226.809V221.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M229.54 226.809V221.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <SystemTooltip
        className="system-tooltip"
        open={opened === "3"}
        closeTooltip={toggle}
        href={iconsData?.at(2)?.href}
        title={iconsData?.at(2)?.label || "Title"}
      >
        <g onMouseEnter={openThird} onClick={openThird}>
          <path
            d="M135.952 275.809V291.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M141.032 275.809V291.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M135.952 291.047H141.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M135.952 275.809H141.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M174.048 275.809V291.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168.968 291.047H174.048"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168.968 275.809V291.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M174.048 275.809H168.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M141.032 288.508H168.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M141.032 278.35H151.19"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168.968 278.35H158.81"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M151.19 275.809V278.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M158.81 275.809V278.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M151.19 275.809H158.809"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M155 270.731C159.909 270.731 163.889 266.751 163.889 261.842C163.889 256.933 159.909 252.953 155 252.953C150.091 252.953 146.111 256.933 146.111 261.842C146.111 266.751 150.091 270.731 155 270.731Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M155 261.842L158.592 258.25"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M152.46 275.809V270.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M157.54 275.809V270.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <defs>
        <clipPath id="clip0_518_6973">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(95 336)"
          />
        </clipPath>
        <clipPath id="clip1_518_6973">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(207 203)"
          />
        </clipPath>
        <clipPath id="clip2_518_6973">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(135 252)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LombardiaSystemsMap;
